<template>
  <div>
    <div v-if="dowlandLink">
      <a
        :href="dowlandLink"
        target="_blank"
        v-if="dowlandLink"
        class="download-template"
        >Descargar foto</a
      >
    </div>
    <div v-if="isVisible" class="card-file-upload-ipt">
      <div class="card-file-upload-ipt-text">
        <span>{{ nameFile }}</span>
        <p>Archivo cargado</p>
      </div>
      <button @click.prevent="removeFile" :disabled="isBusy">
        <img
          class=""
          :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
        />
      </button>
    </div>
    <div v-else>
      <form
        id="file-upload-form"
        class="uploader"
        @dragover.prevent
        @drop="handleDrop"
      >
        <input
          id="filePhoto"
          type="file"
          @change="filesSelected"
          accept="image/*"
        />
        <label for="filePhoto" id="file-drag" class="pointer upload-ipt">
          <div>
            <img src="@/assets/images/icons/upload-cloud-2-line.svg" />
          </div>
          <p>
            Adjunta aquí foto del empleado que participo en la calificación
          </p>
          <button id="ipt-btn" @click.prevent="openFileExplorerIPT">
            Cargar archivo
          </button>
        </label>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: ["filePhoto", "isBusy", "dowlandLink"],
  data() {
    return {
      nameFile: null,
      file: null,
      isVisible: false,
    };
  },
  // watch: {
  //   filePhoto() {
  //     const me = this;
  //     me.loadFile();
  //   },
  // },
  methods: {
    filesSelected(event) {
      event.preventDefault();
      const me = this;
      const file = document.querySelector("#filePhoto");
      me.file = file.files[0];
      me.nameFile = file.files[0].name;
      me.validateFile();
    },
    handleDrop(event) {
      const me = this;
      event.preventDefault();
      me.file = event.dataTransfer.files[0];
      me.nameFile = me.file.name;
      me.validateFile();
    },
    openFileExplorerIPT() {
      document.querySelector("#filePhoto").click();
    },
    validateFile() {
      const me = this;
      if (
        me.file.type !== "image/png" &&
        me.file.type !== "image/jpeg" &&
        me.file.type !== "image/jpg"
      ) {
        me.nameFile = null;
        me.file = null;
        me.$bvToast.toast("El archivo debe ser .png, .jpg, .jpeg", {
          title: "Error al subir el archivo",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
          solid: true,
        });
        return false;
      }

      me.isVisible = me.file ? true : false;
      me.$emit("uploadFile", me.file);
    },
    removeFile() {
      const me = this;
      me.nameFile = null;
      me.file = null;
      me.isVisible = false;
      me.$emit("uploadFile", me.file);
    },
    // loadFile() {
    //   const me = this;
    //   if (me.filePhoto) {
    //     me.file = me.filePhoto;
    //     me.nameFile = me.filePhoto.name;
    //     me.isVisible = me.filePhoto ? true : false;
    //   }
    // },
  },
  // mounted() {
  //   const me = this;
  //   me.loadFile();
  // },
};
</script>

<style lang="scss">
.upload-ipt {
  display: flex !important;
  justify-content: space-between !important;
  gap: 10px !important;
  align-items: center !important;
  padding: 8px !important;
  border-radius: 8px;
  position: relative;
  z-index: 999;
}
.upload-ipt p {
  font-size: 12px !important;
  margin-bottom: 0 !important;
  text-align: left !important;
  color: #263238 !important;
}
.upload-ipt img {
  width: 32px !important;
  height: 32px !important;
}
.upload-ipt button {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 32px;
  border-radius: 4px;
  font-size: 16px;
  border: none;
  color: white;
  padding: 6px 0px;
  width: 230px;
  justify-content: center;
}
.card-file-upload-ipt {
  display: flex;
  justify-content: space-between;
  height: 60px;
  width: 350px;
  padding: 12px 8px 12px 8px;
  border-radius: 4px;
  border: 1px solid #eceff1;
  background-color: white;
  margin-bottom: 5px;
}
.card-file-upload-ipt .card-file-upload-ipt-text {
  display: flex;
  flex-direction: column;
  justify-content: start;
  font-size: 12px;
  color: #263238;
}
.card-file-upload-ipt .card-file-upload-ipt-text p {
  font-size: 12px;
  color: #0c9e42;
}
.card-file-upload-ipt button {
  border: none;
  background-color: transparent;
  padding: 0;
}
.download-template {
  font-size: 14px;
  color: #0c9e42;
  text-decoration: underline;
  cursor: pointer;
}
</style>
